import React, { Suspense, lazy } from "react";

// Libraries
import { Routes, Route } from "react-router-dom";

const Home = lazy(() => import("./Pages/Home/Home"));

function App() {
  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Suspense>
  );
}

export default App;
